import ResetPasswordPage from "./ResetPasswordPage";

export default ResetPasswordPage;

export * from "./ResetPasswordPage";
